import { c as _c } from "react/compiler-runtime";
import { SchDistfeatures } from '@/src/constants/SchDistfeature';
import type { ISchoolFeature } from '../home.interface';
import { Schooldistrictfeature } from './Schooldistrictfeature';
export const Schooldistrictfeatures = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="container mx-auto"><h2 className="mt-24 text-center text-[34px] font-[500] text-[#3d3e40] md:mb-16 md:text-[54px]">School/District Features</h2>{SchDistfeatures.map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(schdistfeature, index) {
  return <Schooldistrictfeature schdistfeature={{
    ...schdistfeature,
    imageUrl: `/images/icons/schdistfeatures/feature-${index + 1}`
  }} index={index + 1} key={index} />;
}